var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team"},[_c('div',{staticClass:"ban"}),_c('Leader'),_c('Patent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }